import React, { useRef } from "react";
import { useEffect, useState } from "react/cjs/react.development";
import { IconSvg } from "./iconBlock/allIcons";
import styles from "./fullPaletteCanvas.module.css";

export default function FullPaletteCanvas({
  swatches,
  swatchSize = 46,
  setFullPaletteCanvas,
  sourceSwatchSize,
  outputType,
}) {
  const canvasRef = useRef();
  const [imagesLoaded, setImagesLoaded] = useState(0);

  useEffect(() => {
    if (!swatches || imagesLoaded < swatches.length) return;
    const canvas = canvasRef.current;
    const outputCanvas = document.createElement("canvas");
    outputCanvas.width = canvas.width;
    outputCanvas.height = canvas.height;

    const ctx = outputCanvas.getContext("2d");
    ctx.drawImage(canvas, 0, 0);

    setFullPaletteCanvas(outputCanvas);
  }, [imagesLoaded, swatches, setFullPaletteCanvas]);

  useEffect(() => {
    const canvas = canvasRef.current;

    canvas.width = swatches.length * sourceSwatchSize;
    canvas.height = sourceSwatchSize * 2;

    for (let i = 0; i < swatches.length; i++) {
      const svg = document.getElementById(`icon-${i}`);
      if (!svg) return;

      // let { width, height } = svg.getBoundingClientRect();
      // let clonedSvgElement = svg.cloneNode(true);
      let outerHTML = svg.outerHTML;
      let blob = new Blob([outerHTML], { type: "image/svg+xml;charset=utf-8" });
      let blobURL = window.URL.createObjectURL(blob);

      let image = new Image();
      image.onload = () => {
        let ctx = canvas.getContext("2d");
        // draw image in canvas starting left-0 , top - 0

        const destX = i * sourceSwatchSize;
        let destY = 0;
        const srcW = sourceSwatchSize;
        const srcH = sourceSwatchSize;

        ctx.drawImage(
          image,
          0,
          0,
          srcW,
          srcH,
          destX,
          destY,
          sourceSwatchSize,
          sourceSwatchSize
        );

        // worksheet version
        destY = sourceSwatchSize;
        ctx.drawImage(
          image,
          0,
          srcH,
          srcW,
          srcH,
          destX,
          destY,
          sourceSwatchSize,
          sourceSwatchSize
        );
        setImagesLoaded((prev) => prev + 1);
      };
      image.src = blobURL;
    }
  }, [swatches, swatchSize, sourceSwatchSize]);

  return (
    <div className={styles.hidden}>
      <canvas ref={canvasRef} className={styles.iconCanvas} />

      {swatches.map((swatch, i) => (
        <div key={i} style={{ lineHeight: 0 }}>
          <IconSvg
            swatch={swatch}
            size={sourceSwatchSize}
            iconIndex={i}
            id={i}
            outputType={outputType}
          />
        </div>
      ))}
    </div>
  );
}
